import { Label } from 'components/ui/label'
import ConfigOptionsDropdown from './config-options-dropdown'
import { UserResponsibleTypeEnum } from '@/services/dtos/enums/accessAutomation.enum';

interface UserClassOptionSelectProps {
    onChange: (value: { value: UserResponsibleTypeEnum, label: string }) => void;
    defaultClass?: UserResponsibleTypeEnum;
    allowedClasses?: UserResponsibleTypeEnum[];
};

function UserClassOptionSelect({ onChange, defaultClass, allowedClasses }: UserClassOptionSelectProps) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const allOptions = Object.entries(UserResponsibleTypeEnum).map(([ _, value]) => {
        return { label: value, value: value }
    });
    const selectOptions = allowedClasses
        ? allOptions.filter(opt => allowedClasses.includes(opt.value as UserResponsibleTypeEnum))
        : allOptions;

    return (
        <div className='flex flex-col w-fit gap-2'>
            <Label>Tipo de Acesso: </Label>
            <ConfigOptionsDropdown
                onChange={onChange}
                defaultValue={{ label: defaultClass, value: defaultClass }}
                options={selectOptions}
                placeholder='Selecionar Classe de Usuário'
            />
        </div>
    )
}

export default UserClassOptionSelect
